<mat-paginator
  *ngIf="(dataService.feedback$ | async).data.length"
  [length]="(dataService.feedback$ | async).meta.total"
  [pageIndex]="getPageIndex(filterService.filter$ | async)"
  [pageSize]="(filterService.filter$ | async).limit"
  [pageSizeOptions]="[10, 20, 50, 100]"
  showFirstLastButtons
  (page)="pageChange($event)"
></mat-paginator>
